module.exports = __webpack_public_path__ + "static/media/naomi-woods-lose.a51278bf.jpg";